import { Injectable } from '@angular/core';
import { SpiaggiaService } from './spiaggia.service';
import { serviziRest, versionNr } from 'src/environments/environment';
import { HttprequestService } from '../httprequest.service';
import { AlertService } from '../alert-service.service';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular/lazy';
import { PrivacyConsentService, SocialChannel } from '../privacy-consent.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  datiUtente = { "password": "", "email": "", "nome": "", "cognome": "", "telefono": "", isSubscribedToNewsletter: false };
  serviziRest: any;
  hasStripeToken: boolean = false;
  isUserLoggedIn: boolean;
  isUserLoggedInGoogle: boolean = false;
  isUserLoggedInApple: boolean = false;
  isUserLoggedInFacebook: boolean = false;
  idTokenGoogle: any;
  idTokenApple: any;
  versionNr: string = '';
  platformOs: string = '';
  constructor(
    private spiaggiaService: SpiaggiaService,
    private platform: Platform,
    private http: HttprequestService,
    private alertService: AlertService,
    private router: Router,
    private privacyConsent: PrivacyConsentService
  ) {
    this.serviziRest = serviziRest;

  }

  private socialChannelFromProvenienza(provenienza: string): SocialChannel | null {
    if (provenienza === 'facebookLogin') return 'facebook';
    if (provenienza === 'googleSignIn') return 'google';
    if (provenienza === 'appleSignIn') return 'apple';
    return null;
  }

  getDatiUtente(email, provenienza, firstLogin = false) {
    let postData = {
      "email": email

    };

    this.http.doPostApplicationJsonBearer(this.serviziRest.getUtente, postData)
      .subscribe(async res => {
        if (!res.uuid || typeof res.uuid !== 'string') {
          this.alertService.alertGenericError();
          this.spiaggiaService.logout();
          return;
        }
        res.stripeToken == 1 ? this.hasStripeToken = true : false;
        this.datiUtente.nome = res.nome;
        this.datiUtente.isSubscribedToNewsletter = res.isSubscribedToNewsletter;
        this.datiUtente.cognome = res.cognome;
        this.datiUtente.telefono = res.telefono;
        this.datiUtente.email = email;

        if (this.datiUtente.nome == null || this.datiUtente.nome == '' ||
          this.datiUtente.cognome == null || this.datiUtente.cognome == '' ||
          this.datiUtente.telefono == null || this.datiUtente.telefono == ''
        ) {

          if (provenienza == '') {
            this.isUserLoggedIn = true;
          } else if (provenienza == 'facebookLogin') {
            this.isUserLoggedInFacebook = true;
            this.isUserLoggedInGoogle = false;
            this.isUserLoggedInApple = false;
          } else if (provenienza == 'googleSignIn') {
            this.isUserLoggedInFacebook = false;
            this.isUserLoggedInGoogle = true;
            this.isUserLoggedInApple = false;
          } else if (provenienza == 'appleSignIn') {
            this.isUserLoggedInFacebook = false;
            this.isUserLoggedInGoogle = false;
            this.isUserLoggedInApple = true;
          }
          else {
            this.isUserLoggedIn = true;
            this.isUserLoggedInFacebook = false;
            this.isUserLoggedInGoogle = false;
            this.isUserLoggedInApple = false;
          }

          this.router.navigate(['/signup-completa']);
        } else {
          if (firstLogin) {
            const channel = this.socialChannelFromProvenienza(provenienza);
            if (channel) {
              const consentOk = await this.privacyConsent.ensureConsent(channel);
              if (!consentOk) {
                this.spiaggiaService.logout();
                this.router.navigate(['/welcome']);
                return;
              }
            }
          }
          this.isUserLoggedIn = true;
          if (firstLogin) {
            this.router.navigate(['/mainpage']);
          }
        }

      }, error => {
        if (error.status == 0) {
          this.alertService.alertAddressError();
        } else if (error.status == 400 || error.status == 401 || error.status == 403) {
          this.alertService.alertWrongCredentials();
        } else {
          this.alertService.alertGenericError();
        }
      });


  }

  checkAppPlatform() {
    if (this.platform.is('android')) {
      this.platformOs = 'android';
      this.spiaggiaService.isPlatformAndroid = true;
      this.spiaggiaService.isPlatformIos = false;
      this.spiaggiaService.isPlatformWeb = false;
    } else if (this.platform.is('ios')) {
      this.spiaggiaService.isPlatformAndroid = false;
      this.spiaggiaService.isPlatformIos = true;
      this.platformOs = 'ios';
      this.spiaggiaService.isPlatformWeb = false;
    } else if (this.platform.is('desktop')) {
      this.spiaggiaService.isPlatformAndroid = false;
      this.spiaggiaService.isPlatformIos = false;
      this.spiaggiaService.isPlatformWeb = true;
      this.platformOs = 'other';
    } else {
      this.platformOs = 'other';

    }
    this.versionNr = versionNr;
    this.platformOs = this.platformOs;
    //console.log(versionNr, this.platformOs);
  }


  setDatiUtente() {
    this.spiaggiaService.updateDatiLoader();
    let postData = {
      "nome": this.datiUtente.nome,
      "cognome": this.datiUtente.cognome,
      "telefono": this.datiUtente.telefono,
      "image": ''

    };


    this.http.doPostApplicationJsonBearer(this.serviziRest.setUtente, postData)
      .subscribe(() => {
        this.spiaggiaService.stoppaLoader();
        this.getDatiUtente(this.datiUtente.email, '');

      }, error => {
        this.spiaggiaService.stoppaLoader();
        // console.log(error.status);
        if (error.status == 0) {
          this.alertService.alertAddressError();
        } else if (error.status == 400 || error.status == 401 || error.status == 403) {
          this.alertService.alertWrongCredentials();
        } else {
          this.alertService.alertGenericError();
        }

        console.log(error);
      });


  }



}
